import {DotLottiePlayer, type DotLottieCommonPlayer} from '@dotlottie/react-player'
import type {LinkField} from '@prismicio/client'
import cn from 'classnames'
import {linkResolver} from 'prismicio'
import {useRef, useState} from 'react'

export const AnimationPlayer = ({src, loop = false}: {src: LinkField; loop?: boolean}) => {
  const dLottiePlayerRef = useRef<DotLottieCommonPlayer>(null)
  const [shouldAppear, setshouldAppear] = useState(false)
  return (
    <DotLottiePlayer
      loop={loop}
      src={linkResolver(src)}
      ref={dLottiePlayerRef}
      onEvent={(event) => {
        if (event === 'ready') {
          setTimeout(() => setshouldAppear(true), 300)

          setTimeout(() => {
            dLottiePlayerRef.current?.play()
          }, 600)
        }

        if (event === 'frame') {
          type LottieInternals = {_lottie?: {currentFrame: number; totalFrames: number}}
          const player = dLottiePlayerRef.current as unknown as LottieInternals | null
          const lottieInstance = player?._lottie

          if (lottieInstance && lottieInstance.currentFrame === lottieInstance.totalFrames) {
            dLottiePlayerRef.current?.pause()
          }
        }
      }}
      className={cn('ease overflow-hidden transition-all duration-300', {
        'opacity-100': shouldAppear,
        'opacity-0': !shouldAppear,
      })}
    />
  )
}
